/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconVacuumCleaner = createReactComponent("vacuum-cleaner", "IconVacuumCleaner", [
  ["path", { d: "M21 12a9 9 0 1 1 -18 0a9 9 0 0 1 18 0z", key: "svg-0" }],
  ["path", { d: "M14 9a2 2 0 1 1 -4 0a2 2 0 0 1 4 0z", key: "svg-1" }],
  ["path", { d: "M12 16h.01", key: "svg-2" }]
]);

export { IconVacuumCleaner as default };
//# sourceMappingURL=IconVacuumCleaner.js.map
